let _onData = [];
const _supportedEvents = ['tab', 'tabFinish', 'save', 'saveFinish'];

/**
 * Bindet bestimmte Events.
 *
 * Unterstuetzte Events:
 *   tab [tabName] func - Nach erfolgreichem Laden eines Tabs.
 *
 * @param {String} eventName
 * @returns {Esearcher}
 */
export function on(eventName, arg1, arg2) {
    if (_supportedEvents.indexOf(eventName) !== -1) {

        var eventHandler = {
            eventName: eventName,
            tab: null,
            func: null
        };

        if (typeof arg1 === 'string') {
            eventHandler.tab = arg1;
            eventHandler.func = arg2;
        } else {
            eventHandler.func = arg1;
        }

        _onData.push(eventHandler);

        return this;
    }

    throw new Error('Event ' + eventName + ' is unkown. ' +
        'Maybe you intended to use a jQuery-Event?');
}

/**
 * Removes the event from the Esearcher event array.
 *
 * @param eventName
 * @returns {Esearcher}
 */
export function off(eventName) {
    var localEventName = eventName;
    _onData = _onData.filter(function (value) {
        return localEventName !== value.eventName;
    });
    return this;
}

/**
 * Erlaubt das Triggern Esearcher-spezifischer Events.
 *
 * @param {String} eventName Name des zu triggernden Events
 * @param {Object} data Daten fuer das Event
 * @returns {Esearcher}
 */
export function trigger(eventName, data) {

    if (_supportedEvents.indexOf(eventName) !== -1) {
        _onData.forEach(function (handler) {

            if (handler.eventName === eventName &&
                    (handler.tab === null || handler.tab === data.tab)) {
                // @todo was: handler.func.call(Esearcher, data);
                handler.func(data);
            }
        });

        return this;
    }

    throw new Error('Event ' + eventName + ' is unkown. ' +
            'Maybe you intended to trigger a jQuery-Event?');
}
